// import React from 'react';
import ReactDOM from 'react-dom/client';
// import reportWebVitals from './reportWebVitals';
import './i18n';
import App from './App';

declare global {
  interface UserSettingsDataObject {
    locale: object | undefined;
  }
  interface Window {
    userSettings: UserSettingsDataObject;
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('app') as HTMLElement,
);
// https://reactjs.org/docs/strict-mode.html#detecting-unexpected-side-effects
// in strict mode, constructor of react components is called twice
root.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
